// MY CHRISTMAS — Prompt: premium login + purchase/activation flow (5 languages).
// Flat keys (used via t("login.title")). Country/market sets price; language sets text.
export const extra11 = {
  pt: {
    "login.suspended": "Seu acesso está suspenso (compra reembolsada ou cancelada). Fale com o suporte se precisar de ajuda.",
    "login.title": "ENTRAR NO MY CHRISTMAS",
    "login.subtitle": "Já possui acesso? Entre para continuar organizando o seu Natal.",
    "login.cta": "ENTRAR",
    "login.noaccess_title": "Ainda não tem acesso?",
    "login.noaccess_text": "O acesso ao MY CHRISTMAS é liberado após a confirmação da compra.",
    "login.steps": ["Escolha seu acesso", "Faça o pagamento", "Receba o e-mail de ativação", "Crie sua senha e entre no MY CHRISTMAS"],
    "login.buy_cta": "🎄 QUERO ACESSAR O MY CHRISTMAS",
    "login.access_label": "Acesso ao MY CHRISTMAS — Natal 2026",
    "login.one_time": "Pagamento único",
    "login.price_for": "Preço para {country}",
    "login.err_title": "Não encontramos um acesso ativo para este e-mail.",
    "login.err_text": "Confira o endereço informado ou conheça o MY CHRISTMAS.",
    "login.retry": "Tentar novamente",
    "login.know": "Quero conhecer o MY CHRISTMAS",
    "login.locked": "Muitas tentativas. Tente novamente em alguns minutos.",
    "login.tooltip": "Para quem já possui acesso",
    "create.title": "CRIE SUA SENHA",
    "create.sub": "Defina uma senha para acessar o seu MY CHRISTMAS.",
    "create.new": "Nova senha",
    "create.confirm": "Confirmar senha",
    "create.req_len": "Pelo menos 6 caracteres",
    "create.req_match": "As duas senhas coincidem",
    "create.cta": "CRIAR SENHA E CONTINUAR",
    "create.mismatch": "As senhas não coincidem.",
    "create.success_title": "Sua senha foi criada com sucesso. 🎄",
    "create.success_sub": "Tudo pronto! Agora é só entrar e começar a preparar o seu Natal.",
    "create.success_kept": "Senha criada para {buyer}. Você continua conectado como {current} — a sessão atual foi preservada. Para entrar como comprador, saia e faça login com o novo e-mail.", "create.success_cta_kept": "Voltar à minha conta",
    "create.success_cta": "ENTRAR NO MY CHRISTMAS",
    "pending.title": "ESTAMOS AGUARDANDO A CONFIRMAÇÃO DO SEU PAGAMENTO",
    "pending.text": "Assim que a confirmação for recebida, enviaremos as instruções de acesso para o seu e-mail.",
    "pending.back": "Voltar ao início",
    "thanks.title": "Pagamento recebido! 🎄",
    "thanks.text": "Obrigado por escolher o MY CHRISTMAS. Seu acesso está sendo liberado e você receberá um e-mail em instantes.",
    "thanks.pending_title": "Recebemos seu pedido!",
    "thanks.pending_text": "Seu pagamento está aguardando confirmação (boleto ou Pix). Assim que for aprovado, enviaremos o e-mail de acesso.",
    "thanks.step1_title": "Verifique seu e-mail",
    "thanks.step1_text": "Enviamos uma mensagem com o assunto “Seu acesso ao MY CHRISTMAS está pronto” para o e-mail usado na compra.",
    "thanks.step2_title": "Crie sua senha",
    "thanks.step2_text": "Clique em “CRIAR MINHA SENHA” no e-mail e escolha uma senha segura.",
    "thanks.step3_title": "Entre e comece seu Natal",
    "thanks.step3_text": "Acesse com seu e-mail e senha e comece a organizar decoração, ceia, presentes e muito mais.",
    "thanks.spam": "Não encontrou? Verifique a caixa de spam ou promoções. O e-mail pode levar alguns minutos.",
    "thanks.cta": "JÁ CRIEI MINHA SENHA — ENTRAR",
    "admin.pay.title": "Pagamentos",
    "admin.pay.desc": "Checkout único global da Monetizze — usado por todos os mercados (/br, /us, /pt, /fr, /es, /it).",
    "admin.pay.provider": "Provedor",
    "admin.pay.url": "URL do checkout global",
    "admin.pay.url_ph": "https://... (link único da Monetizze)",
    "admin.pay.active": "Ativo",
    "admin.pay.validation": "Validação internacional",
    "admin.pay.pending": "Pendente",
    "admin.pay.validated": "Validado",
    "admin.pay.save": "Salvar configuração",
    "admin.pay.saved": "Configuração salva.",
    "admin.pay.note": "Enquanto a URL estiver vazia ou inativa, os botões de compra mostram \"em breve\". Os mercados abaixo definem apenas o preço exibido — todos usam o mesmo checkout.",
  },
  en: {
    "login.suspended": "Your access is suspended (purchase refunded or cancelled). Contact support if you need help.",
    "login.title": "LOG IN TO MY CHRISTMAS",
    "login.subtitle": "Already have access? Log in to keep organizing your Christmas.",
    "login.cta": "LOG IN",
    "login.noaccess_title": "Don't have access yet?",
    "login.noaccess_text": "Access to MY CHRISTMAS is unlocked after your purchase is confirmed.",
    "login.steps": ["Choose your access", "Complete the payment", "Get the activation email", "Create your password and log in"],
    "login.buy_cta": "🎄 I WANT ACCESS TO MY CHRISTMAS",
    "login.access_label": "MY CHRISTMAS Access — Christmas 2026",
    "login.one_time": "One-time payment",
    "login.price_for": "Price for {country}",
    "login.err_title": "We couldn't find active access for this email.",
    "login.err_text": "Check the address you entered or discover MY CHRISTMAS.",
    "login.retry": "Try again",
    "login.know": "Discover MY CHRISTMAS",
    "login.locked": "Too many attempts. Please try again in a few minutes.",
    "login.tooltip": "For people who already have access",
    "create.title": "CREATE YOUR PASSWORD",
    "create.sub": "Set a password to access your MY CHRISTMAS.",
    "create.new": "New password",
    "create.confirm": "Confirm password",
    "create.req_len": "At least 6 characters",
    "create.req_match": "Both passwords match",
    "create.cta": "CREATE PASSWORD AND CONTINUE",
    "create.mismatch": "Passwords don't match.",
    "create.success_title": "Your password was created successfully. 🎄",
    "create.success_sub": "All set! Just log in and start preparing your Christmas.",
    "create.success_kept": "Password created for {buyer}. You are still signed in as {current} — your current session was kept. To use the new account, sign out and log in with the new e-mail.", "create.success_cta_kept": "Back to my account",
    "create.success_cta": "LOG IN TO MY CHRISTMAS",
    "pending.title": "WE'RE WAITING FOR YOUR PAYMENT CONFIRMATION",
    "pending.text": "As soon as it's confirmed, we'll email you the access instructions.",
    "pending.back": "Back to home",
    "thanks.title": "Payment received! 🎄",
    "thanks.text": "Thank you for choosing MY CHRISTMAS. Your access is being activated and you'll receive an email shortly.",
    "thanks.pending_title": "We received your order!",
    "thanks.pending_text": "Your payment is awaiting confirmation. As soon as it's approved, we'll send your access email.",
    "thanks.step1_title": "Check your email",
    "thanks.step1_text": "We sent a message titled “Your MY CHRISTMAS access is ready” to the email used at checkout.",
    "thanks.step2_title": "Create your password",
    "thanks.step2_text": "Click “CREATE MY PASSWORD” in the email and choose a secure password.",
    "thanks.step3_title": "Log in and start your Christmas",
    "thanks.step3_text": "Sign in with your email and password and start organizing decoration, dinner, gifts and much more.",
    "thanks.spam": "Can't find it? Check your spam or promotions folder. The email may take a few minutes.",
    "thanks.cta": "I'VE CREATED MY PASSWORD — LOG IN",
  },
  es: {
    "login.suspended": "Tu acceso está suspendido (compra reembolsada o cancelada). Contacta con soporte si necesitas ayuda.",
    "login.title": "ENTRAR EN MY CHRISTMAS",
    "login.subtitle": "¿Ya tienes acceso? Entra para seguir organizando tu Navidad.",
    "login.cta": "ENTRAR",
    "login.noaccess_title": "¿Aún no tienes acceso?",
    "login.noaccess_text": "El acceso a MY CHRISTMAS se activa tras la confirmación de la compra.",
    "login.steps": ["Elige tu acceso", "Realiza el pago", "Recibe el correo de activación", "Crea tu contraseña y entra"],
    "login.buy_cta": "🎄 QUIERO ACCEDER A MY CHRISTMAS",
    "login.access_label": "Acceso a MY CHRISTMAS — Navidad 2026",
    "login.one_time": "Pago único",
    "login.price_for": "Precio para {country}",
    "login.err_title": "No encontramos un acceso activo para este correo.",
    "login.err_text": "Revisa la dirección introducida o conoce MY CHRISTMAS.",
    "login.retry": "Intentar de nuevo",
    "login.know": "Quiero conocer MY CHRISTMAS",
    "login.locked": "Demasiados intentos. Inténtalo de nuevo en unos minutos.",
    "login.tooltip": "Para quienes ya tienen acceso",
    "create.title": "CREA TU CONTRASEÑA",
    "create.sub": "Define una contraseña para acceder a tu MY CHRISTMAS.",
    "create.new": "Nueva contraseña",
    "create.confirm": "Confirmar contraseña",
    "create.req_len": "Al menos 6 caracteres",
    "create.req_match": "Las dos contraseñas coinciden",
    "create.cta": "CREAR CONTRASEÑA Y CONTINUAR",
    "create.mismatch": "Las contraseñas no coinciden.",
    "create.success_title": "Tu contraseña se creó correctamente. 🎄",
    "create.success_sub": "¡Listo! Solo entra y empieza a preparar tu Navidad.",
    "create.success_kept": "Contraseña creada para {buyer}. Sigues conectado como {current}; tu sesión actual se ha conservado. Para usar la nueva cuenta, cierra sesión e inicia con el nuevo e-mail.", "create.success_cta_kept": "Volver a mi cuenta",
    "create.success_cta": "ENTRAR EN MY CHRISTMAS",
    "pending.title": "ESTAMOS ESPERANDO LA CONFIRMACIÓN DE TU PAGO",
    "pending.text": "En cuanto se confirme, te enviaremos las instrucciones de acceso por correo.",
    "pending.back": "Volver al inicio",
    "thanks.title": "¡Pago recibido! 🎄",
    "thanks.text": "Gracias por elegir MY CHRISTMAS. Tu acceso se está activando y recibirás un correo en unos instantes.",
    "thanks.pending_title": "¡Recibimos tu pedido!",
    "thanks.pending_text": "Tu pago está pendiente de confirmación. En cuanto se apruebe, te enviaremos el correo de acceso.",
    "thanks.step1_title": "Revisa tu correo",
    "thanks.step1_text": "Enviamos un mensaje con el asunto “Tu acceso a MY CHRISTMAS está listo” al correo usado en la compra.",
    "thanks.step2_title": "Crea tu contraseña",
    "thanks.step2_text": "Haz clic en “CREAR MI CONTRASEÑA” en el correo y elige una contraseña segura.",
    "thanks.step3_title": "Entra y empieza tu Navidad",
    "thanks.step3_text": "Accede con tu correo y contraseña y empieza a organizar decoración, cena, regalos y mucho más.",
    "thanks.spam": "¿No lo encuentras? Revisa la carpeta de spam o promociones. El correo puede tardar unos minutos.",
    "thanks.cta": "YA CREÉ MI CONTRASEÑA — ENTRAR",
  },
  fr: {
    "login.suspended": "Votre accès est suspendu (achat remboursé ou annulé). Contactez le support si besoin.",
    "login.title": "SE CONNECTER À MY CHRISTMAS",
    "login.subtitle": "Vous avez déjà accès ? Connectez-vous pour continuer à organiser votre Noël.",
    "login.cta": "SE CONNECTER",
    "login.noaccess_title": "Vous n'avez pas encore accès ?",
    "login.noaccess_text": "L'accès à MY CHRISTMAS est activé après la confirmation de l'achat.",
    "login.steps": ["Choisissez votre accès", "Effectuez le paiement", "Recevez l'e-mail d'activation", "Créez votre mot de passe et connectez-vous"],
    "login.buy_cta": "🎄 JE VEUX ACCÉDER À MY CHRISTMAS",
    "login.access_label": "Accès à MY CHRISTMAS — Noël 2026",
    "login.one_time": "Paiement unique",
    "login.price_for": "Prix pour {country}",
    "login.err_title": "Nous n'avons pas trouvé d'accès actif pour cet e-mail.",
    "login.err_text": "Vérifiez l'adresse saisie ou découvrez MY CHRISTMAS.",
    "login.retry": "Réessayer",
    "login.know": "Découvrir MY CHRISTMAS",
    "login.locked": "Trop de tentatives. Réessayez dans quelques minutes.",
    "login.tooltip": "Pour ceux qui ont déjà accès",
    "create.title": "CRÉEZ VOTRE MOT DE PASSE",
    "create.sub": "Définissez un mot de passe pour accéder à votre MY CHRISTMAS.",
    "create.new": "Nouveau mot de passe",
    "create.confirm": "Confirmer le mot de passe",
    "create.req_len": "Au moins 6 caractères",
    "create.req_match": "Les deux mots de passe correspondent",
    "create.cta": "CRÉER LE MOT DE PASSE ET CONTINUER",
    "create.mismatch": "Les mots de passe ne correspondent pas.",
    "create.success_title": "Votre mot de passe a été créé avec succès. 🎄",
    "create.success_sub": "C'est prêt ! Connectez-vous et commencez à préparer votre Noël.",
    "create.success_kept": "Mot de passe créé pour {buyer}. Vous êtes toujours connecté en tant que {current} — votre session a été conservée. Pour utiliser le nouveau compte, déconnectez-vous puis connectez-vous avec le nouvel e-mail.", "create.success_cta_kept": "Retour à mon compte",
    "create.success_cta": "SE CONNECTER À MY CHRISTMAS",
    "pending.title": "NOUS ATTENDONS LA CONFIRMATION DE VOTRE PAIEMENT",
    "pending.text": "Dès la confirmation reçue, nous vous enverrons les instructions d'accès par e-mail.",
    "pending.back": "Retour à l'accueil",
    "thanks.title": "Paiement reçu ! 🎄",
    "thanks.text": "Merci d'avoir choisi MY CHRISTMAS. Votre accès est en cours d'activation et vous recevrez un e-mail dans quelques instants.",
    "thanks.pending_title": "Nous avons reçu votre commande !",
    "thanks.pending_text": "Votre paiement est en attente de confirmation. Dès qu'il sera approuvé, nous vous enverrons l'e-mail d'accès.",
    "thanks.step1_title": "Vérifiez votre e-mail",
    "thanks.step1_text": "Nous avons envoyé un message intitulé « Votre accès à MY CHRISTMAS est prêt » à l'adresse utilisée lors de l'achat.",
    "thanks.step2_title": "Créez votre mot de passe",
    "thanks.step2_text": "Cliquez sur « CRÉER MON MOT DE PASSE » dans l'e-mail et choisissez un mot de passe sécurisé.",
    "thanks.step3_title": "Connectez-vous et commencez votre Noël",
    "thanks.step3_text": "Connectez-vous avec votre e-mail et votre mot de passe et commencez à organiser décoration, repas, cadeaux et bien plus.",
    "thanks.spam": "Vous ne le trouvez pas ? Vérifiez vos spams ou promotions. L'e-mail peut prendre quelques minutes.",
    "thanks.cta": "J'AI CRÉÉ MON MOT DE PASSE — ME CONNECTER",
  },
  it: {
    "login.suspended": "Il tuo accesso è sospeso (acquisto rimborsato o annullato). Contatta il supporto se hai bisogno di aiuto.",
    "login.title": "ACCEDI A MY CHRISTMAS",
    "login.subtitle": "Hai già accesso? Accedi per continuare a organizzare il tuo Natale.",
    "login.cta": "ACCEDI",
    "login.noaccess_title": "Non hai ancora accesso?",
    "login.noaccess_text": "L'accesso a MY CHRISTMAS viene attivato dopo la conferma dell'acquisto.",
    "login.steps": ["Scegli il tuo accesso", "Completa il pagamento", "Ricevi l'e-mail di attivazione", "Crea la tua password e accedi"],
    "login.buy_cta": "🎄 VOGLIO ACCEDERE A MY CHRISTMAS",
    "login.access_label": "Accesso a MY CHRISTMAS — Natale 2026",
    "login.one_time": "Pagamento unico",
    "login.price_for": "Prezzo per {country}",
    "login.err_title": "Non abbiamo trovato un accesso attivo per questa e-mail.",
    "login.err_text": "Controlla l'indirizzo inserito o scopri MY CHRISTMAS.",
    "login.retry": "Riprova",
    "login.know": "Scopri MY CHRISTMAS",
    "login.locked": "Troppi tentativi. Riprova tra qualche minuto.",
    "login.tooltip": "Per chi ha già accesso",
    "create.title": "CREA LA TUA PASSWORD",
    "create.sub": "Imposta una password per accedere al tuo MY CHRISTMAS.",
    "create.new": "Nuova password",
    "create.confirm": "Conferma password",
    "create.req_len": "Almeno 6 caratteri",
    "create.req_match": "Le due password coincidono",
    "create.cta": "CREA PASSWORD E CONTINUA",
    "create.mismatch": "Le password non coincidono.",
    "create.success_title": "La tua password è stata creata con successo. 🎄",
    "create.success_sub": "Tutto pronto! Accedi e inizia a preparare il tuo Natale.",
    "create.success_kept": "Password creata per {buyer}. Sei ancora connesso come {current}: la sessione attuale è stata mantenuta. Per usare il nuovo account, esci e accedi con la nuova e-mail.", "create.success_cta_kept": "Torna al mio account",
    "create.success_cta": "ACCEDI A MY CHRISTMAS",
    "pending.title": "STIAMO ASPETTANDO LA CONFERMA DEL TUO PAGAMENTO",
    "pending.text": "Appena confermato, ti invieremo via e-mail le istruzioni di accesso.",
    "pending.back": "Torna alla home",
    "thanks.title": "Pagamento ricevuto! 🎄",
    "thanks.text": "Grazie per aver scelto MY CHRISTMAS. Il tuo accesso è in attivazione e riceverai un'e-mail tra pochi istanti.",
    "thanks.pending_title": "Abbiamo ricevuto il tuo ordine!",
    "thanks.pending_text": "Il tuo pagamento è in attesa di conferma. Appena sarà approvato, ti invieremo l'e-mail di accesso.",
    "thanks.step1_title": "Controlla la tua e-mail",
    "thanks.step1_text": "Abbiamo inviato un messaggio con oggetto “Il tuo accesso a MY CHRISTMAS è pronto” all'indirizzo usato per l'acquisto.",
    "thanks.step2_title": "Crea la tua password",
    "thanks.step2_text": "Clicca su “CREA LA MIA PASSWORD” nell'e-mail e scegli una password sicura.",
    "thanks.step3_title": "Accedi e inizia il tuo Natale",
    "thanks.step3_text": "Entra con e-mail e password e inizia a organizzare decorazione, cena, regali e molto altro.",
    "thanks.spam": "Non la trovi? Controlla la cartella spam o promozioni. L'e-mail può richiedere qualche minuto.",
    "thanks.cta": "HO CREATO LA MIA PASSWORD — ACCEDI",
  },
};
